import { Dayjs } from 'dayjs';
import { WeekDayIndex } from 'types/availability';

export default function findNearestWeekStart(
  date: Dayjs,
  startOfWeek: WeekDayIndex
) {
  if (date.weekday() !== startOfWeek) {
    const newDate = date.weekday(startOfWeek);
    if (newDate.isAfter(date)) {
      return newDate;
    }

    return newDate.add(1, 'week');
  }

  return date;
}
